module.exports = __webpack_public_path__ + "static/media/h270_10.0416ccc4bf0ecd6b27b0832a05d55bf0.png";